module.exports = __webpack_public_path__ + "static/media/wa-background-dark.2c2b95e0.jpg";